import { AxiosResponse, CancelToken } from 'axios';
import { awBridgeApi } from '../../Base';
import { mutateProposedAwaAnalysisBenchmarkData } from '../../utils';
import { AWProposalAnalystRequestV4, AWProposalAnalystResponseV4 } from './Models';

// AWM-18057 special timeout for the analyze call
const ANALYZE_API_TIMEOUT = 600000;

/**
 * This is being used in PRD and Focus.
 * @param request
 * @param cancelToken
 */
export function postProposalAnalystV4(
  request: AWProposalAnalystRequestV4,
  cancelToken?: CancelToken
): Promise<AxiosResponse<AWProposalAnalystResponseV4>> {
  const path = '/v4/proposals/analyze';

  /**
   * AWM-18811 -- If there is no proposed benchmark, copy over the original benchmark. This may happen if AWPA turns off
   * calculating benchmark analytics in proposed due to size/compute concerns. This is likely a tactical fix
   * until we can refactor it more broadly in the app.
   */
  return new Promise<AxiosResponse<AWProposalAnalystResponseV4>>((resolve, reject) => {
    awBridgeApi
      .post<AWProposalAnalystResponseV4>(path, request, {
        params: { pkg: request.pkg },
        cancelToken,
        timeout: ANALYZE_API_TIMEOUT,
      })
      .then((result) => {
        if (!result?.data.analysis) {
          reject();
          throw Error('Missing analysis data from postProposalAnalystV4 response');
        }

        // Only mutate benchmark data if proposalAwaAnalysis is present
        if (result?.data.analysis.proposalAwaAnalysis) {
          const { original, proposed } = result.data.analysis.proposalAwaAnalysis;
          mutateProposedAwaAnalysisBenchmarkData(original, proposed);
        }

        /*
         * Story 3191150: partial analysis responses (analysis object present but some sub-fields omitted)
         * are valid and should be treated as a successful response. Resolve for any present analysis.
         */
        resolve(result);
      })
      .catch((e) => {
        reject(e);
      });
  });
}
